// SEQ-240: "How is this worked out" text for the Dashboard's "P&L month on
// month" section. Edit this file whenever dashboardMonthOnMonth.ts changes.
//
// WHAT IT DESCRIBES (line numbers at commit 3eed3d4):
// - dashboardMonthOnMonth.ts 46-64: one row, calculated.net_profit, company
//   total, at month grain (pnl_analytics_query reports raw wages for a single
//   month, wagesMultiplierGrain.ts), with the Change column on.
// - dashboardMonthOnMonth.ts 114-132: the date mapping. All time becomes this
//   financial year to date up to the last complete month (or the last six
//   complete months when that holds none); any other range is clamped to end
//   at the last complete month.
// - dashboardMonthOnMonth.ts 140-144: the projects are the Dashboard's
//   effective project list (status filter included); none matching shows a
//   message rather than asking for every project.
// - The Net profit row label describes its metric through describeMetric
//   (pnlMetricDescriptions.ts) with DASHBOARD_MOM_DESCRIBE_CONTEXT below.
//
// dashboardFigureDefinitions.test.ts checks every id here is used by a
// component and every id a component uses is here.

import type { MetricDefinition } from "../../components/howWorkedOut/metricDefinition";
import type { DescribeContext } from "./pnlMetricDescriptions";

const MOM_DATES_DETAIL =
  "Complete months only, so the range stops at last month. On All time it shows this financial year to date (the last six complete months in early July).";

/** The projects and dates every metric row on the Dashboard's month on month table shares. */
export const DASHBOARD_MOM_DESCRIBE_CONTEXT: DescribeContext = {
  projects: { scope: "filters" },
  dates: { scope: "date-filter", detail: MOM_DATES_DETAIL },
  period: "One column per complete month.",
};

export const DASHBOARD_MOM_FIGURES = {
  "pnl-month-on-month": {
    name: "P&L month on month",
    meaning: "Net profit for each complete month, with the change between the last two.",
    formula: [
      "Each column: income minus costs for that month, for the projects in view added together.",
      "Months use wages as typed, like the month columns on a project's P&L tab, so they will not add up to a yearly total that applies the wages multiplier.",
      "Change: the last month minus the month before it, in dollars and as a percentage of the month before.",
    ],
    source: {
      kind: "mixed",
      detail: "The same figures as P&L Analytics: income from the progress claims, costs typed in on each project's P&L tab. Xero is not counted.",
    },
    projects: { scope: "filters" },
    dates: { scope: "date-filter", detail: MOM_DATES_DETAIL },
    period: "One column per complete month.",
  },
} satisfies Record<string, MetricDefinition>;
